import React from 'react';
import { alpha } from '@mui/material/styles';
import {
  AddCircleOutline as AddIcon,
  RemoveCircleOutline as RemoveIcon,
  SwapHoriz as TransferIcon,
  Tune as AdjustIcon,
  Inventory2Outlined as OpeningIcon,
} from '@mui/icons-material';
import { STOCK_ACCENT } from './stockMobileLayout';
import {
  formatBookingAuditTime,
  getBookingAuditActorChipSx,
  getBookingAuditDrawerHeaderSx,
  getBookingAuditDrawerPaperSx,
  getBookingAuditEmptyStateSx,
  getBookingAuditEventCardSx,
  getBookingAuditEventTypeChipSx,
  getBookingAuditMetaChipSx,
  getBookingAuditRefreshButtonSx,
  getBookingAuditRefreshRowSx,
  getBookingAuditTimelineAvatarSx,
  getBookingAuditTimelineConnectorSx,
} from './bookingAuditLayout';
import { getBookingDrawerTheme, getGuestDrawerMetaChipSx } from './bookingDrawerLayout';

export {
  formatBookingAuditTime,
  getBookingAuditActorChipSx,
  getBookingAuditDrawerHeaderSx,
  getBookingAuditDrawerPaperSx,
  getBookingAuditEmptyStateSx,
  getBookingAuditEventCardSx,
  getBookingAuditEventTypeChipSx,
  getBookingAuditMetaChipSx,
  getBookingAuditRefreshButtonSx,
  getBookingAuditRefreshRowSx,
  getBookingAuditTimelineAvatarSx,
  getBookingAuditTimelineConnectorSx,
  getGuestDrawerMetaChipSx,
};

const STOCK_IN_COLOR = '#66d4a8';
const STOCK_OUT_COLOR = '#ef5350';
const ADJUST_COLOR = '#ffb74d';
const TRANSFER_COLOR = '#8ac9ff';

export function getStockAuditEventPresentation(eventType) {
  const normalized = String(eventType || '').toUpperCase();

  if (normalized === 'STOCK_IN') {
    return { icon: <AddIcon sx={{ fontSize: 18 }} />, color: STOCK_IN_COLOR };
  }
  if (normalized === 'OPENING_STOCK') {
    return { icon: <OpeningIcon sx={{ fontSize: 18 }} />, color: STOCK_IN_COLOR };
  }
  if (normalized === 'TRANSFER_IN') {
    return { icon: <TransferIcon sx={{ fontSize: 18 }} />, color: STOCK_IN_COLOR };
  }
  if (normalized === 'STOCK_OUT') {
    return { icon: <RemoveIcon sx={{ fontSize: 18 }} />, color: STOCK_OUT_COLOR };
  }
  if (normalized === 'TRANSFER_OUT') {
    return { icon: <TransferIcon sx={{ fontSize: 18 }} />, color: STOCK_OUT_COLOR };
  }
  if (normalized === 'ADJUSTMENT') {
    return { icon: <AdjustIcon sx={{ fontSize: 18 }} />, color: ADJUST_COLOR };
  }
  return { icon: <AddIcon sx={{ fontSize: 18 }} />, color: STOCK_ACCENT };
}

export function getStockAuditDrawerPaperSx(isDark, extra = {}) {
  return getBookingAuditDrawerPaperSx(isDark, extra);
}

export function getStockAuditSummaryChipSx(isDark, color) {
  const tokens = getBookingDrawerTheme(isDark);
  return {
    height: 22,
    fontSize: '0.68rem',
    backgroundColor: isDark ? alpha(color, 0.14) : alpha(color, 0.1),
    color: isDark ? alpha(color, 0.95) : color,
    border: `1px solid ${alpha(color, isDark ? 0.35 : 0.28)}`,
  };
}

export function getStockAuditBalanceChipSx(isDark) {
  const tokens = getBookingDrawerTheme(isDark);
  return {
    height: 22,
    fontSize: '0.68rem',
    backgroundColor: isDark ? alpha(STOCK_ACCENT, 0.12) : alpha(STOCK_ACCENT, 0.08),
    color: isDark ? tokens.text : '#0f172a',
    border: `1px solid ${alpha(STOCK_ACCENT, 0.28)}`,
  };
}
